import {BORDER_STYLE, FONT_SIZE, TEXT_FILL_STYLE} from '../Charts/chartStyle'

export const NUMBER_FONT_FAMILY = 'Times New Roman'

export const TEXT_FONT_FAMILY = 'simsun'

export const AXIS_LINE_STYLE = {
  color: `rgb(${BORDER_STYLE.join(',')})`
}

export const AXIS_LABEL = {
  fontSize: FONT_SIZE,
  color: TEXT_FILL_STYLE
}



// WEBPACK FOOTER //
// ./src/components/Data/FactorCharts/chartStyle.js